export interface TextCardProps {
  icon: string;
  title: string;
  text: string;
}

export const CARD_BG = 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hd3ohe_854066.png';

export const CARD_TEXT = [
  '传统的线下学术会议准备流程长、组织成本高，流程涵盖会场布置、嘉宾接待、现场人员协同、内容研讨等多场景需求；不仅受到场地限制，也会因为展示、交流方式单一，影响嘉宾的参会体验。',
  '瑶台提供的线上虚拟学术会议场景方案，既能提高主办方组织会议的效率，又能满足参会者的多场景需求，提升专家、学者的参会体验。融合视频研讨、线上社交、会议组织等多功能需求的一站式活动方案，等你体验。',
];

export const DEMANDS = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5ypaz_icon4.png',
    title: '高效组织',
    text: '协同讲师完成会议配置、日程管理、嘉宾沟通等全链路筹备工作，快速提高组织效率。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5ypay_icon3.png',
    title: '学术互动',
    text: '支持论文提交、圆桌会议、poster 展板交流、多主题多形式报告等学术互动形式，并可协助讲师记录现场专家意见。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5ypax_icon2.png',
    title: '场景定制',
    text: '结合主办方需求，支持不同类型会场定制和海报墙、留言板、展览区、坐席排布等场地装修，增加活动创新体验。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5muwx_icon1.png',
    title: '虚拟社交',
    text: '通过音视频畅聊、私信、发言、名片发送等功能，多场景满足社交需求，提高会议互动效果。',
  },
];

export const FEATURES = [
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220907/l7r5842t_285732.png',
    title: '便捷性的复杂议程管理',
    desc: [
      '后台管理系统快捷创建活动信息，自由设置活动时间',
      '随时设置活动主页、开场白、公告议程，完成学术大紧凑饱满的日程安排',
    ],
  },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1k_920375.png',
    title: '沉浸式的交流感官体验',
    desc: [
      'AI 智能捏脸，打造讲师及嘉宾虚拟形象',
      '投屏、畅聊应有尽有，学术会议必备的大会报告、口头报告、墙报讨论等一应俱全',
    ],
  },
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1o_920379.png',
    title: '多样化的沉浸式场地',
    desc: [
      '高精度复刻线下活动的多种会议厅、会客室、沙龙间、会展馆等，满足学术会议的多种场地需求',
      '更多创意场景随心定制，古风、火星、沙漠、山川、海底，用虚拟情景实现参会新体验',
    ],
  },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1p_920380.png',
    title: '个性化的服装和动作',
    desc: ['支持定制校服、学位服、西装礼服等多种个性化服装', '支持定制颁奖、拨穗等多种礼节动作'],
  },
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1q_920381.png',
    title: '创意性的内容策划',
    desc: ['提供全系列内容策划，包括图、文、音视频等', '结合具体需求，定制专属活动创新玩法'],
  },
  // {
  //   rightText: false,
  //   image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1j_920375.png',
  //   title: '系统化的项目复盘',
  //   desc: ['报名及签到人数、讲师听课率等数据收集', '参会专家数据管理及会议多维度信息统计分析，助力活动复盘与改进'],
  // },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7igzaul_834413.png',
    title: '高质量的业务价值提升',
    desc: ['为展商、赞助商提供多方位品牌内容展示', '整合传播资源提升活动宣传效果'],
  },
];

export const L_ADVANTAGES = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd7_icon3.png',
    title: '一站式服务',
    text: '	瑶台一站式全流程技术服务，满足学术会议在会前、会中、会后各环节的多样性需求，助力主办方提升会议组织与运营效率，优化专家、学者参会体验。',
  },
  // {
  //   icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd6_icon2.png',
  //   title: '上市企业品牌背书',
  //   text: '网易是纳斯达克及香港上市企业，作为中国领先的互联网技术公司，在市场上具有较强的影响力，并获得了广泛用户群体的信任。瑶台是整合网易集团优势资源和能力，打造的服务活动市场的新平台',
  // },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd5_icon1.png',
    title: '最前沿的核心技术',
    text: '依托人工智能研究和应用的顶尖机构——网易伏羲实验室，瑶台拥有数字人、智能捏脸、表情动作迁移、三维场景重建等多项行业最前沿的核心 AI 技术，助力提升用户体验。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd8_icon4.png',
    title: '个性化定制',
    text: '主办方可以量身定制虚拟活动场地、虚拟角色形象、虚拟交互和会务组织功能，满足多样化活动需求。',
  },
];

export const L_SUCCESS_CASES = [
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '第二届分布式人工智能国际会议',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220905/l7ohmtlz_728871.png',
    brief:
      // autocorrect: false
      '2020年10月24日-27日，南京大学人工智能学院在瑶台中举行了第二届国际分布式人工智能学术会议（DAI 2020）。包括图灵奖得主、中国科学院外籍院士 John E. Hopcroft 教授在内的 300 余位全球人工智能领域的知名学者“穿越”到古色古香的虚拟世界中，畅谈前沿 AI 技术。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '第十六届国际生物矿化研讨会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220611/l49jpa4o_case4.png',
    brief:
      // autocorrect: false
      '2021年8月23日-26日，第十六届生物矿化国际研讨会在瑶台沉浸式活动平台中召开。来自中国、美国、德国、法国、日本等 20 个国家的 300 余位生物矿化领域专家和学者汇聚一堂，交流生物矿化领域的最新研究进展并展望未来发展趋势。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '第 28 届国际低温工程大会暨低温工程材料大会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220905/l7ohmtlx_728868.png',
    brief:
      // autocorrect: false
      '2022年4月25日-29 日，第 28 届国际低温工程大会暨 2022 年低温工程材料大会在浙江大学以“元宇宙”沉浸式虚拟会议方式成功举行，开创了线上国际交流的全新模式，打造多元创新体验',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '中欧校友（苏州）总部大厦产业规划大会',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7sfr3tb_434191.png',
    brief:
      // autocorrect: false
      '2022年5月8日，中欧校友（苏州）总部大厦产业规划发布会在线上元宇宙惊艳开幕，300+中欧校友与各界来宾虚拟化身一键穿越，汇智瑶台，共同展望中欧校友总部大厦产业规划及未来发展。',
  },
  {
    tags: ['AI 捏脸', '动作交互', '全网直播'],
    title: '北大光华碳中和前沿沙龙',
    cover: 'https://static.fuxi.netease.com/yaotai/portal/20220908/l7sfr098_429579.png',
    brief:
      // autocorrect: false
      '2022年5月27日，北大光华碳中和前沿沙龙在网易瑶台虚拟场景中举行，主题聚焦“碳中和与消费变革”。近百位与会者与北京大学光华管理学院翁翕教授、高彧教授一起，探讨碳中和前沿新知，体验别样的沉浸氛围。',
  },
];
